import React, { useEffect, useState } from "react";
import { endPoints } from "../../constant/Environment";
import { addData, getAllData } from "../../Utility/API";
import { Button } from "react-bootstrap";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Checkbox from "@mui/material/Checkbox";
import Loader from "../../components/Loader";
import { ErrorToast, SuccesToast } from "../../components/Toast/message";

// Checkbox matrix: CHECKED = that segment is EXCLUDED from seeing that offer.
const SegmentationModal = ({ open, onClose, offers }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [segments, setSegments] = useState([]);
  const [excluded, setExcluded] = useState({}); // { "popupId_segmentId": true }

  useEffect(() => {
    if (!open) return;
    setIsLoading(true);
    Promise.all([
      getAllData(endPoints.api.playertypes),
      getAllData(endPoints.api.POPUP_SEGMENTATION_ALL),
    ])
      .then(([types, exclusions]) => {
        setSegments(types?.data || []);
        const map = {};
        (exclusions?.data || []).forEach((row) => {
          map[`${row.popup_id}_${row.player_type_id}`] = true;
        });
        setExcluded(map);
      })
      .catch((e) => console.error(e))
      .finally(() => setIsLoading(false));
  }, [open]);

  const toggle = (popupId, segmentId) => {
    const key = `${popupId}_${segmentId}`;
    setExcluded((prev) => ({ ...prev, [key]: !prev[key] }));
  };

  const save = async () => {
    setIsLoading(true);
    try {
      for (const offer of offers) {
        const playerTypeIds = segments
          .filter((s) => excluded[`${offer.id}_${s.Id ?? s.id}`])
          .map((s) => s.Id ?? s.id);
        await addData(endPoints.api.POPUP_SEGMENTATION_SAVE, {
          popupId: offer.id,
          playerTypeIds,
        });
      }
      SuccesToast("Segmentation saved.");
      onClose();
    } catch (e) {
      console.error(e);
      ErrorToast("Save failed");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Dialog sx={{ "& .MuiDialog-paper": { width: "95%" } }} maxWidth="lg" open={open}>
      <DialogTitle>Popup Segmentation (checked = excluded)</DialogTitle>
      <DialogContent dividers>
        {isLoading && <Loader spinner={true} visible={isLoading} />}
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Offer</TableCell>
              {segments.map((s) => (
                <TableCell key={s.Id ?? s.id} align="center">
                  {s.player_type ?? s.playerType}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {offers.map((offer) => (
              <TableRow key={offer.id}>
                <TableCell>{offer.name}</TableCell>
                {segments.map((s) => {
                  const segId = s.Id ?? s.id;
                  return (
                    <TableCell key={segId} align="center">
                      <Checkbox
                        checked={!!excluded[`${offer.id}_${segId}`]}
                        onChange={() => toggle(offer.id, segId)}
                      />
                    </TableCell>
                  );
                })}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={save}>Save</Button>
      </DialogActions>
    </Dialog>
  );
};

export default SegmentationModal;
